import Vue from 'vue'
import Vuex from 'vuex'
import Other from './modules/other'
import { Getter } from './modules/getter'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    Other
  },
  getters: Getter
})
